import { render, staticRenderFns } from "./RulesetShuttle.vue?vue&type=template&id=af354bb4&scoped=true"
import script from "./RulesetShuttle.vue?vue&type=script&lang=js"
export * from "./RulesetShuttle.vue?vue&type=script&lang=js"
import style0 from "./RulesetShuttle.vue?vue&type=style&index=0&id=af354bb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af354bb4",
  null
  
)

export default component.exports